export default {
  'issuesVoids.header': 'Add Check Issue(s)/Void(s)',

  'issuesVoids.issuedChecks': 'Issued Checks for',
  'issuesVoids.voidedChecks': 'Voided Checks',

  'issuesVoids.checkIssueNumber': 'Check Issue Number',

  'issuesVoids.validation.greaterThan': 'Amount must be greater than $0.00',
  'issuesVoids.error.maxNumber': 'Max number of 25 exceeded',
  'issuesVoids.sign.maxNumberPerForm': 'Max 25 per form',
  'issuesVoids.error.isNumber': 'Check issue number must be numeric',

  'issuesVoids.confirmToLeavePage':
    'Are you sure you want to leave this page? All unsaved changes will be lost.',
  'issuesVoids.successMessage':
    '<%= issuedCount %> Check Issue/ <%= voidedCount %> Void Submitted',
  'issuesVoids.cutoffWarning':
    'Cutoff time is <%= cutOffTime %> ET. Cutoff time has passed. All added items will be processed the next business day.',

  'issuesVoids.CheckIssueNumberExists': 'Check issue number already exists',
  'issuesVoids.AmountIssueAndPaidCheckNotMatch':
    'Amount for check issue - <%= checkIssueNumber %> and paid check - <%= checkIssueNumber %> do not match',
  'issuesVoids.AmountIssueAndVoidCheckNotMatch':
    'Amount for check issue - <%= checkIssueNumber %> and void - <%= checkIssueNumber %> do not match'
};
